import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import { Form, Formik, Field } from "formik";
import Spinner from "web/components/Spinner";
import HOCButton from "web/components/Button";
import NumberInput from "web/components/form-elements/NumberInput";
import TextInput from "web/components/form-elements/TextInput";
import PhoneNumber from "web/components/form-elements/PhoneNumber";
import RadioButton from "web/components/form-elements/RadioButton";
import DatePicker from 'web/components/form-elements/DatePicker';
import Select from 'web/components/form-elements/Select';
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';
import { adminAddLocationApi, adminUpdateLocationApi, checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import { InputFieldsWrapper } from '../PTPlusStyled'
import AlertModal from 'web/components/AlertModal';
import CloseIcon from "web/assets/images/CloseIcon.png";
import { stateConvert } from "web/components/utils/stateAbbreviation";

function AddEditLocationModal(pageProps) {
  const dispatch = useDispatch();
  let history = useHistory()
  const isInitialRender = useRef(true);
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [alertType, setAlertType] = useState('')
  const [saveDisableState, setSaveDisableState] = useState(true)
  const [isValidZip, setIsValidZip] = useState(true)
  let pageFieldValues = pageProps.formikProps.values

  let currencyList = [{ value: "USD", label: 'USD' }]

  const [locationTypeList, setLocationTypeList] = useState([])

  useEffect(() => {
    if (pageProps.editLocationDetails) {
      let locationDetails = pageProps?.editLocationDetails?.address
      pageProps.setFieldValue('addLocationName', locationDetails?.locationName)
      pageProps.setFieldValue('addLocationAddress', locationDetails?.street)
      pageProps.setFieldValue('addLocationCity', locationDetails?.city)
      pageProps.setFieldValue('addLocationState', locationDetails?.state)
      pageProps.setFieldValue('addLocationZip', locationDetails?.zipCode)
      pageProps.setFieldValue('addLocationContactNumber', locationDetails?.contactNumber)
    } else {
      pageProps.setFieldValue('addLocationName', '')
      pageProps.setFieldValue('addLocationAddress', '')
      pageProps.setFieldValue('addLocationCity', '')
      pageProps.setFieldValue('addLocationState', '')
      pageProps.setFieldValue('addLocationZip', '')
      pageProps.setFieldValue('addLocationContactNumber', '')
    }
  }, [])

  useEffect(() => {
    let fieldValues = pageProps.formikProps.values
    if (!pageProps.formikProps.errors.addLocationContactNumber && fieldValues.addLocationName !== '' && fieldValues.addLocationAddress !== '' && fieldValues.addLocationCity !== '' && fieldValues.addLocationState !== ''
      && fieldValues.addLocationZip !== '' && fieldValues.addLocationContactNumber !== '') setSaveDisableState(false)
    else setSaveDisableState(true)
  }, [pageProps.formikProps])

  const addLocationFunction = async () => {
    let fieldValues = pageProps.formikProps.values
    let response = ''
    let id = pageProps.pageData.id
    let data = {
      locationAddress: {
        name: fieldValues.addLocationName?.trim(),
        contactNumber: fieldValues.addLocationContactNumber,
        locationName: fieldValues.addLocationName?.trim(),
        street: fieldValues.addLocationAddress?.trim(),
        city: fieldValues.addLocationCity,
        state: fieldValues.addLocationState,
        zipCode: fieldValues.addLocationZip
      }
    }
    const token = localStorage.getItem('token')
    response = await dispatch(adminAddLocationApi(id, data, token))
    if (response.success) {
      setAlertModalContent('Location added successfully.')
      setAlertType('adminAddEditLocation')
      setAlertModal(!alertModal)
    } else {
      if (response?.data?.error?.message === 'Address already exists.') {
        setAlertModalContent('Location already exists.')
        setAlertModal(!alertModal)
      } else if (response.statusCode === 401) {
        adminLogout()
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again in some time.')
        setAlertModal(!alertModal)
      }
    }
  }

  const editLocationFunction = async () => {
    let response = ''
    let fieldValues = pageProps.formikProps.values
    let data = {
      customerId: pageProps.pageData.id,
      locationId: pageProps.editLocationDetails?.locationId,
      locationName: fieldValues.addLocationName?.trim(),
      contactNumber: fieldValues.addLocationContactNumber,
      street: fieldValues.addLocationAddress?.trim(),
      city: fieldValues.addLocationCity,
      state: fieldValues.addLocationState,
      zipCode: fieldValues.addLocationZip
    }
    const token = localStorage.getItem('token')
    response = await dispatch(adminUpdateLocationApi(data, token))
    if (response.success) {
      setAlertModalContent('Location details updated successfully.')
      setAlertType('adminAddEditLocation')
      setAlertModal(!alertModal)
    } else {
      if (response?.data?.error?.message === 'Address already exists.') {
        setAlertModalContent('Location already exists.')
        setAlertModal(!alertModal)
      } else if (response.statusCode === 401) {
        adminLogout()
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again in some time.')
        setAlertModal(!alertModal)
      }
    }
  }

  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}))
    dispatch(logoutAdmin())
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    history.push('./sign-in')
    window.location.reload(false);
  }

  const zipChangeHandler = async (value) => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    const token = localStorage.getItem('token')
    let response = '';
    if (value.length === 5) {
      response = await dispatch(checkIsZipCode(value, token))
      if (response.success) {
        setIsValidZip(true)
        pageProps.setFieldValue('addLocationState', stateConvert(response.data?.state) || response.data?.state)
        pageProps.setFieldValue('addLocationCity', response.data?.city)
      } else {
        if (response?.data?.error?.message === 'Invalid Zip Code.') {
          setIsValidZip(false)
          pageProps.setFieldValue('addLocationState', '')
          pageProps.setFieldValue('addLocationCity', '')
        } else if (response.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response.message || 'Something went wrong, please try again.')
          setAlertModal(!alertModal)
        }
      }
    } else {
      setIsValidZip(true)
      pageProps.setFieldValue('addLocationState', '')
      pageProps.setFieldValue('addLocationCity', '')
    }
  }

  return (
    <>
      {loaderVisible && <Spinner />}
      <div>
        <div className="modal-header-style">
          <h6>{pageProps?.editLocationDetails ? 'Edit Location' : 'Add Location'}</h6>
          <img src={CloseIcon} alt="close-icon" onClick={() => {
            pageProps.formikProps.resetForm()
            pageProps.toggle()
          }} />
        </div>


        <div style={{ padding: '25px' }}>
          <InputFieldsWrapper>

            <div className="row">
              <div className="col-md-6 fixed-height">
                {pageFieldValues.addLocationName !== '' && <h6>Location Name<span className='star'>&#42;</span></h6>}
                <div className='height-adjust'><TextInput name='addLocationName' placeholder={`Location Name*`} inputType='companyAndLocationText' /></div>
              </div>
              <div className="col-md-6 fixed-height">
                {pageFieldValues.addLocationAddress !== '' && <h6>Address<span className='star'>&#42;</span></h6>}
                <div className='height-adjust'><TextInput name='addLocationAddress' placeholder={`Address*`} /></div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 fixed-height">
                {pageFieldValues.addLocationCity !== '' && <h6>City<span className='star'>&#42;</span></h6>}
                <div className='height-adjust'><TextInput name="addLocationCity" placeholder={`City*`} inputType='text' /></div>
              </div>
              <div className="col-md-6 fixed-height">
                {pageFieldValues.addLocationState !== '' && <h6 className='mb-2'>State<span className='star'>&#42;</span></h6>}
                <div className='height-adjust'><TextInput name="addLocationState" placeholder={`State*`} disabled inputType='text' /></div>
              </div>
            </div>
            <div className="row">
              <div className={!isValidZip ? 'col-md-6 fixed-height error-styling-input' : 'col-md-6 fixed-height'}>
                {pageFieldValues.addLocationZip !== '' && <h6 className='mb-2'>Zip<span className='star'>&#42;</span></h6>}
                <div className='height-adjust'><NumberInput name="addLocationZip" placeholder={`Zip*`} maxLength={5} callBackFlag={true} callBackFun={zipChangeHandler} />
                  {!isValidZip && <p style={{ marginTop: '-7px' }}>Zipcode is invalid.</p>}
                </div>
              </div>
              <div className="col-md-6 fixed-height">
                {pageFieldValues.addLocationContactNumber !== '' && <h6>Contact Number<span className='star'>&#42;</span></h6>}
                <div className='height-adjust'><PhoneNumber name="addLocationContactNumber" placeholder={`Contact Number*`} /></div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                className='green-button'
                style={{ opacity: saveDisableState ? 0.5 : 1 }}
                disabled={saveDisableState}
                onClick={pageProps?.editLocationDetails ? editLocationFunction : addLocationFunction}>{pageProps?.editLocationDetails ? 'Update Location' : 'Add Location'}</button>
            </div>
          </InputFieldsWrapper>
        </div>
      </div>
      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType={alertType}
        callBackAlert={() => {
          if (alertType === 'adminAddEditLocation') {
            pageProps.refreshUserData(pageProps?.pageData?.id)
            pageProps.fetchLocationsListFunction()
            pageProps.toggle()
          }
        }}
      />
    </>
  );
}

export default AddEditLocationModal;
